import React from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon } from '@pearsontechnology/aero-components';

import Link from 'data/Link';

import { Wrapper, RRLink } from './styles';

const WorkspaceBreadcrumbs = ({ links }) => (
  <Wrapper>
    {links.map((link) => (
      <React.Fragment key={link.url}>
        <RRLink to={link.url}>{link.text}</RRLink>
        <MaterialIcon id="chevron_right" />
      </React.Fragment>
    ))}
  </Wrapper>
);

WorkspaceBreadcrumbs.propTypes = {
  links: PropTypes.arrayOf(PropTypes.instanceOf(Link)).isRequired,
};

export default WorkspaceBreadcrumbs;
